import axios from 'axios';

// Create axios instance
const axiosInstance = axios.create({
  baseURL: '/controllers/auth_proxy.php',
});

axiosInstance.interceptors.response.use(
  (response) => {
    // Check if PHP returned a new JWT
    if (response.data.token) {
      // Update stored JWT
      localStorage.setItem('token', response.data.token)
    }

    return response;
  },
  (error) => {
    // handle errors
    return Promise.reject(error);
  }
);

const buildUrl = (path) => `?path=${encodeURIComponent(path)}`;

export const authClient = {
  get: (path, config = {}) => 
    axiosInstance.get(buildUrl(path), config).then(r => r.data),

  post: (path, data, config = {}) =>
    axiosInstance.post(buildUrl(path), data, config).then(r => r.data),

  put: (path, data, config = {}) =>
    axiosInstance.put(buildUrl(path), data, config).then(r => r.data),

  delete: (path, config = {}) =>
    axiosInstance.delete(buildUrl(path), config).then(r => r.data),
};